/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class Renderer
 * @hideconstructor
 * @classdesc API class that is used to provide a renderer provider extension point
 */
define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'./api/ReactRendererAPI'
], (APIFactory, ReactRendererAPI) => {
	class TooltipRenderer {

		constructor(options) {
			this._api = APIFactory.createAPI(this, [ReactRendererAPI]);
			this._providers = [];
			this._features = options.features;
		}

		registerProvider(provider) {
			if ( this._providers.indexOf(provider) === -1 && typeof(provider.getComponent) === 'function'){
				this._providers.push(provider);
			}
		}

		deregisterProvider(provider) {
			const idx = this._providers.indexOf(provider);
			if ( idx !== -1 ) {
				this._providers.splice(idx, 1);
			}
		}

		getAPI() {
			return this._api;
		}

		canRender() {
			return this._providers.length > 0 ;
		}

		getComponentList(state) {
			const contentList = [];
			if ( this._providers.length > 0) {
				for ( let i = 0 ; i < this._providers.length; i++){
					let component;
					try {
						component = this._providers[i].getComponent(state);
					} catch (error){
						this._features['Logger'].error('Renderer error ' , error);
					}
					if (component){
						contentList.push(component);
					}
				}
			}
			return contentList;
		}

	}

	return TooltipRenderer;
});
